<template>
    <div class="row marketing">
        <div class="col-lg-12">

            <div style="margin-bottom:2em; text-align:center;">
                <span style="padding-right: 1em;">
                    <a style="border-bottom: 2px solid #6AD5BF; padding: .2em; font-weight: bold; color: rgba(0,0,0,.7);">My Submission</a>
                </span>
                <span>
                    <router-link style="color:#6AD5BF;" :to="{path: '/course/' + chapterdata.lCId + '/chapter/' + chapterdata.id + '/allReviews/'}">All Submissions</router-link>
                </span>
            </div>              
            
            <div v-if="getSubmission">
                <p><b>Assignment: </b>{{ chapterdata.assignment }}</p>        
                <div class="user-answer-review">
                  <div style="padding-bottom: 1em; color: rgba(0,0,0,.54);">
                    <span class="card-date">{{ new Date(getSubmission.date).toDateString() }}</span>
                    <span style="font-size: 1em;">Submission</span> by <b>{{ currentUser.displayName }}</b>:
                  </div>
                  <i style="white-space: pre-wrap">{{ getSubmission.content }}</i>
                </div>
            </div>
            
            <div v-if="getReview">
                <div class="review-assessment">
                  <div style="padding-bottom: 2em; color: rgba(0,0,0,.54);">
                    <span class="card-date">{{ new Date(getReview.date).toDateString() }}</span>
                    <span style="font-size: 1em;">Review</span> by <b>{{ getReview.reviewUserEmail }}</b>:
                  </div>
                  <i style="white-space: pre-wrap">{{ getReview.content }}</i>
                </div>
            </div>
            <div v-else>
                <div class="alert alert-warning alert-dismissible fade show" role="alert">
                  <strong>Reviews pending</strong> There are no reviews on your submission yet. We estimate that it will take up to 48 hours until your submission will receive feedback. We will notify you by mail once you have received feedback.
                </div>
            </div>

            <a class="btn btn-outline-primary btn-lg btn-block" style="margin-top:2em;" @click="NextChapterView(chapterdata)">
              Next Chapter
            </a>
            
        </div>
    </div>
</template>
<script>
import { store } from '../../../store/store.js'
import { dbReviewsRef } from '../../../firebaseConfig'

export default {
    props:['chapterdata','UserSubmissionData'],
    data() {
        return{
            currentUser: this.$store.getters.currentUser,
        }
    },
    methods: {
        NextChapterView(chapterdata) {
            console.log(this.getLCData.chapter.length)
            if (chapterdata.id+1 === this.getLCData.chapter.length){
                this.$router.push({path: '/course/' + chapterdata.lCId +'/end/'});
            } else {
                var nextchapter = chapterdata.id+1
                store.dispatch('setChapter', nextchapter);
                this.$router.push({path: '/course/' + chapterdata.lCId + '/chapter/' + nextchapter + '/materials/'});
            }
        }
    },
    computed: {
        getSubmission() {
            var subdata = this.$store.getters.getSubmission2;
            // console.log(subdata)
            if(subdata && this.currentUser){
                var chapterSubmission = subdata.filter( submission => {
                    return  (submission.chapterId == this.chapterdata.id && submission.userId == this.currentUser.uid );
                });
                // console.log(new Date(chapterSubmission[0].date).toDateString());
                return chapterSubmission[0];
            }
        },
        getReview() {
            var subdata2 = this.$store.getters.getReviews;
            // console.log("test")
            // console.log(subdata2)
            if(subdata2 && this.currentUser){
                var chapterReview = subdata2.filter( review => {
                    return  (review.chapterId == this.chapterdata.id && review.submissionUserId == this.currentUser.uid );
                });
                // console.log(chapterReview);
                return chapterReview[0];
            }
        },
        getLCData() {
            var courseId = parseInt(this.$route.params.courseId)
            return this.$store.getters.getCurrentLCData2(courseId)
        },
    },
  created() {
    this.$store.dispatch('setReviewsRef', dbReviewsRef)
  }
}
</script>

<style type="text/css">
.user-answer-review {
    border-radius: .3rem;
    background-color: #E1F6F2;
    padding: 1em;
    margin-bottom: 1em;
}

.review-assessment {
    border-radius: .3rem;
    background-color: #F2F2f2;
    padding: 1em;
}

.card-date {
    color: rgba(0,0,0,.2);
    float: right;
}

</style>


// WEBPACK FOOTER //
// src/components/course/chapter/ChapterReview.vue